module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters-container"
  }, [_c('ul', {
    ref: "dfilters",
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "filters__filter__activator",
    style: ({
      'left': _vm.left,
      'width': _vm.width
    })
  }), _vm._v(" "), _vm._l((_vm.filters), function(filter, idx) {
    return _c('li', {
      staticClass: "filters__filter",
      class: {
        'filters__filter--active': _vm.isFilter(filter.value)
      },
      attrs: {
        "id": 'filter_' + filter.value
      },
      on: {
        "click": function($event) {
          return _vm.setFilter(filter)
        }
      }
    }, [_vm._v("\n      " + _vm._s(filter.label) + "\n      "), _c('span', {
      staticClass: "filter__length"
    }, [_vm._v("(" + _vm._s(filter.length) + ")")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b216f258!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DFilters.vue
// module id = 1726
// module chunks = 1